import React from 'react';
import styled from 'styled-components';

const Popover = ({
  className, position = 'top', show = false, children, title = '',
}) => (
  <div
    className={`${className} popover bs-popover-${position} fade ${show ? 'show' : ''}`}
    role="tooltip"
  >
    <div className="arrow" />
    <h3 className="popover-header">{title}</h3>
    <div className="popover-body">{children}</div>
  </div>
);

export default styled(Popover)`
  pointer-events: ${p => (p.show ? 'initial' : 'none')};
`;
